import $ from 'jquery';

/**
 * Handle header tabs
 *
 * @type {DynamicInitFunction<HTMLElement>}
 */
export default ($collection) => {

	for (const container of $collection) {

		const $container = $(container);
		const $tabsItems = $container.children('.nav-item');
		const options = $container.data('mobile-tabs') || {};
		const $tabsHolder = $(options.containerHtml || '<li class="nav-item-tabs d-none"></li>');
		const $toggleButton = $(options.toggleButtonHtml || '<a class="btn btn-white bg-transparent border-0 px-2" data-bs-toggle="dropdown" href="javascript:void(0);"><span title="View tabs" data-bs-toggle="dropdown"><i class="mdi mdi-dots-horizontal"></i></span></a>');
		const $dropdownContainer = $(options.itemContainerHtml || '<div class="dropdown-menu dropdown-menu-end"></div>');
		const foldOffset = options.foldOffset || 0;

		// Add markup to dom
		$tabsHolder.append($toggleButton);
		$tabsHolder.append($dropdownContainer);
		$container.append($tabsHolder);

		// Mobile tabs collection
		let $tabsDropdownItems = $();
		let tabsTotal = 0;

		// Add mobile tabs as dropdown elements
		for (const tab of $tabsItems) {
			const $tab = $(tab);
			const $tabLink = $tab.children('a.nav-link').first();
			const markup = (options.itemHtml || '<a class="dropdown-item" href="javascript:void(0);"></a>').replaceAll('[[url]]', $tabLink.attr('href')).replaceAll('[[label]]', $tabLink.html());
			const $dropdownItem = $tabLink.hasClass('active') ? $(markup).addClass('active') : $(markup);
			// $dropdownItem.find('.badge').removeClass('bg-light').addClass('bg-secondary');
			$dropdownContainer.append($dropdownItem);
			$tabsDropdownItems = $tabsDropdownItems.add($dropdownItem);
			tabsTotal++;
		}

		// eslint-disable-next-line unicorn/consistent-function-scoping
		const handleTabs = () => {
			let tabsVisible = 0;

			for (const [key, tab] of Object.entries($tabsItems.get())) {
				const $tab = $(tab);
				const index = Number(key);

				if (tab.getBoundingClientRect().right <= (document.documentElement.clientWidth - foldOffset)) {
					tabsVisible++;
					$tab.removeClass('invisible');
					$tabsDropdownItems.eq(index).addClass('d-none');
				}
				else {

					// Don't hide the first tab
					if (tabsVisible >= 1) {
						$tab.addClass('invisible');
						$tabsDropdownItems.eq(index).removeClass('d-none');
					}
				}
			}

			if (tabsVisible === tabsTotal) {
				$tabsHolder.addClass('d-none');
			}
			else {
				$tabsHolder.removeClass('d-none');
			}
		};

		window.addEventListener('resize', handleTabs, { passive: true });
		handleTabs();
		$container.on('destroy', () => window.removeEventListener('resize', handleTabs));
	}
};